/** `13 March 2026 at 12:56` — the long stamp for "last run" and lifecycle tooltips. */
export const formatDateTime = (raw: string | undefined | null): string => {
  if (!raw) return '';
  const date = new Date(raw);
  if (Number.isNaN(date.valueOf())) return '';
  const day = date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  const time = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  return `${day} at ${time}`;
};
